module.exports = __webpack_public_path__ + "lp/img/speaker_icn-blue.1cb8c09d.svg";